import PokemonRouter from "./route/PokemonRouter";

const App = () => {
  return <PokemonRouter />;
};

export default App;
